/**
 * Handle mobile nav.
 */
const navHandle = function() {
  const $nav = $('.js-nav-mobile');
  const $body = $('body');

  $(document).on('click', '.js-mobile-nav-trigger, .js-mobile-nav-close', function(e) {
    e.preventDefault();

    $nav.slideToggle();
    $body.toggleClass('no-scroll');
  });

  $(document).on(
    'click',
    '.mobile-nav .nav__item--has-dropdown a',
    function (e) {
      const $this = $(this);
      const $dropdown = $this.next('.nav__dropdown');
      const $dropdownItem = $this.closest('.nav__item--has-dropdown');

      if ( ! $dropdown.is(':visible') ) {
        e.preventDefault();

        $dropdown.slideToggle();
        $dropdownItem.toggleClass('is-open')
      }
    }
  );
}

navHandle();
